/**
 * Window scroll helpers shared by route guards and pages.
 *
 * Bootstrap 5's reboot sets `:root { scroll-behavior: smooth }`, which turns
 * every plain `window.scrollTo(x, y)` into an animated scroll. Route changes
 * must reposition the window instantly (before paint), otherwise the new page
 * is first painted at the previous page's offset and then visibly glides.
 */

export const disableBrowserScrollRestoration = () => {
  if (typeof window === "undefined") return;
  try {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
  } catch (e) {
    // Some embedded browsers expose a read-only history object
  }
};

export const scrollWindowInstantly = (top = 0) => {
  if (typeof window === "undefined") return;

  const root = document.documentElement;
  const previousInlineBehavior = root.style.scrollBehavior;
  const nextTop = Math.max(0, Math.round(top));

  root.style.scrollBehavior = "auto";
  try {
    window.scrollTo({ top: nextTop, left: 0, behavior: "instant" });
  } catch (e) {
    window.scrollTo(0, nextTop);
  }
  root.style.scrollBehavior = previousInlineBehavior;
};
